import { render, staticRenderFns } from "./LensMetricTable.vue?vue&type=template&id=70dd9f16&scoped=true"
import script from "./LensMetricTable.vue?vue&type=script&lang=js"
export * from "./LensMetricTable.vue?vue&type=script&lang=js"
import style0 from "./LensMetricTable.vue?vue&type=style&index=0&id=70dd9f16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70dd9f16",
  null
  
)

export default component.exports